import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdsComponent } from '../ad/ads.component';
import { AdComponent } from '../ad/ad.component';
import { ClientsComponent } from '../ad/clients.component';
import { CoreService } from '@app/core/core.service';

const routes: Routes = [
  CoreService.childRoutes([{ path: 'ads', component: AdsComponent, data: { title: 'Ads' } },
  { path: 'ad', component: AdComponent, data: { title: 'Ad' } },
  { path: 'clients', component: ClientsComponent, data: { title: 'Clients' } },])];

/* loadChildren: () => import('../feature/path/sample- 
tags.module').then(m => m.CreateLinksModule) */

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AdRoutingModule { }
